import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { IoIosEye } from "react-icons/io";
import { IoIosEyeOff } from "react-icons/io";
import "./Reset.css";
import "../../global/GlobalStyle.css";
import "../../global/Global.css";
import { resetPassword } from "../../../api/ApiConfig";
import toast from "react-hot-toast";
import corevalue from "../../../images/core_value_new.png";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassOne, setShowPasswordOne] = useState(false);
  const [showPassTwo, setShowPasswordTwo] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const validatePassword = (password) => {
    const regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return regex.test(password);
  };

  const handlePasswordChange = async (e) => {
    e.preventDefault();

    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");

    if (!validatePassword(password)) {
      toast.error("Please enter a strong password");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Password mismatch");
      return;
    }

    try {
      const userData = { new_password: password, token: token };
      await resetPassword(userData, (result) => {
        if (result.status == "success") {
          toast.success(result.message);
          localStorage.removeItem("user");
          setPassword("");
          setConfirmPassword("");
          navigate("/");
        }
      });
    } catch (error) {
      toast.error(error.message);
    }
  };

  const togglePasswordVisibilityOne = () => {
    setShowPasswordOne(!showPassOne);
  };
  const togglePasswordVisibilityTwo = () => {
    setShowPasswordTwo(!showPassTwo);
  };

  return (
    <div className="box-describe">
      <div className="box-describe-wrapper">
        {/* Left side view */}
        <div className="box-describe-left-view">
          <>
            <div className="title" style={{ fontSize: "24px" }}>
              Set New Password
            </div>

            {/* Email Field
            <div className="input-field-global-field mt-1">
              <span>Email</span>
              <input
                type="email"
                id="Email"
                placeholder="Enter your email"
                disabled
                // defaultValue={getEmail}
                required
                style={{ width: "320px" }}
              />
            </div>

            {/* OTP Field */}
            {/* <div className="input-field-global-field">
              <span>OTP</span>
              <input
                type="number"
                id="number"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                required
                style={{ width: "320px" }}
              />
            </div> */}

            <div>
              {/* Password Field */}
              <div className="input-field-global-field">
                <p style={{ color: "#6E6E6E" }}>Password</p>
                <input
                  type={showPassOne ? "text" : "password"}
                  id="password"
                  placeholder="Enter Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <p
                  className="password-toggle-icon mt-1"
                  onClick={togglePasswordVisibilityOne}
                >
                  {showPassOne ? <IoIosEye /> : <IoIosEyeOff />}
                </p>
              </div>

              {/* Confirm Password Field */}
              <div className="input-field-global-field">
                <p style={{ color: "#6E6E6E" }}>Confirm Password</p>
                <input
                  type={showPassTwo ? "text" : "password"}
                  id="re-password"
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
                <p
                  className="password-toggle-icon mt-1"
                  onClick={togglePasswordVisibilityTwo}
                >
                  {showPassTwo ? <IoIosEye /> : <IoIosEyeOff />}
                </p>
              </div>
              <div className="button-design-container">
                <button
                  className="button-design w-90"
                  type="submit"
                  onClick={handlePasswordChange}
                >
                  Submit
                </button>
              </div>
            </div>

            {/* <div className="mt-3">
              <a
                href="/forget-password"
                className="back-to-login-link"
                style={{ color: "#1F4F74" }}
              >
                Back
              </a>
            </div> */}
          </>
        </div>

        {/* Right side form */}
        <div className="box-describe-form-right-view">
          <div className="content-container">
            <div className="">
              <h3 className="corevaluehead">Our Vision</h3>
              <p className="corevaluesubhead">
                To become a global IT Services and Solutions provider,
                delivering innovation-led best-in-class technology solutions by
                leveraging data, AI, and emerging technologies.
              </p>
            </div>
            {/* Conditionally render images */}
          </div>
          <div className="mt-4">
            <h3 className="corevaluehead">Our Mission</h3>
            <p className="corevaluesubhead">
              To co-engineer excellence for our customers with their
              transformation journey and in the process create value for all our
              stakeholders.
            </p>
          </div>

          <div className="mt-4">
            <img src={corevalue} alt="Illustration" className="img-container" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
